import Accordion from '@/common/components/Accordion'
import InfoField from '@/common/components/InfoField'
import { formatCurrency } from '@/common/utils/formatters';
import { EquipmentModelLatestFipeData } from '@/features/equipmentModels/types/equipmentModelLatestFipe'

interface FipeMainDataAccordionProps {
  fipeData?: EquipmentModelLatestFipeData
}

export default function FipeMainDataAccordion({ fipeData }: FipeMainDataAccordionProps) {
  const referenceDate = fipeData?.latest_price_reference_month && fipeData?.latest_price_reference_year
    ? `(${fipeData.latest_price_reference_month}/${fipeData.latest_price_reference_year})`
    : '';

  return (
    <Accordion
      name="FipeMainData"
      head="Dados Principais"
      body={
        <div className='flex items-center gap-1'>
          <InfoField 
            label="Código Fipe" 
            value={fipeData?.raw?.["Codigo Fipe"]} 
          />
          <InfoField 
            label="Descrição" 
            value={fipeData?.description} 
          />
          <InfoField 
            label={`Preço atual ${referenceDate}`} 
            value={formatCurrency(Number(fipeData?.latest_price))} 
          />
        </div>
      }
    />
  )
}